import React, { useCallback, useState } from 'react'
import { Loader } from '@components/UI'
import { isTutor, Conversations } from '@helpers'
import { useClassroomUpdate, useFeedbackCreation } from '../../hooks'

import Review from './Review'
import Rating from './Rating'
import End from './End'
import Duration from './Duration'

const STEPS = {
  DURATION: 'DURATION',
  CLASSROOM_REVIEW: 'CLASSROOM_REVIEW',
  RATING: 'RATING',
  REVIEW: 'REVIEW',
  END: 'END'
}

const Feedback = ({
  exit,
  exitToSessionRequest,
  appointment,
  participants,
  small,
  self,
  withDuration,
  showClassroomReview,
  style = {},
  ...props
}) => {
  const getInitialStep = () => {
    if (withDuration) {
      return STEPS.DURATION
    } else if (showClassroomReview) {
      return STEPS.CLASSROOM_REVIEW
    } else if (props.rating) {
      return STEPS.REVIEW
    } else {
      return STEPS.RATING
    }
  }
  const [step, setStep] = useState(getInitialStep())
  const [updating, setUpdating] = useState(false)
  const person = Conversations.getPersonFromParticipants(self, participants)
  const { mutate: sendFeedback } = useFeedbackCreation()
  const { mutateAsync: updateClassroom } = useClassroomUpdate()

  const next = useCallback(() => {
    switch (step) {
      case STEPS.DURATION:
        return setStep(STEPS.CLASSROOM_REVIEW)
      case STEPS.CLASSROOM_REVIEW:
        return setStep(STEPS.RATING)
      case STEPS.RATING:
        return setStep(STEPS.REVIEW)
      case STEPS.REVIEW:
        return setStep(STEPS.END)
    }
  }, [step])

  const update = useCallback(
    (body) => {
      setUpdating(true)

      updateClassroom(body).then(
        () => {
          setUpdating(false)
          next()
        },
        () => {
          setUpdating(false)
        }
      )
    },
    [next, updateClassroom]
  )

  const submitClassroomFeedback = (review) => {
    const body = { user: self._id, data: review.trim() }
    if (body.data && !updating) {
      setUpdating(true)
      sendFeedback(body, {
        onError: () => setUpdating(false),
        onSuccess: () => {
          setUpdating(false)
          next()
        }
      })
    }
  }

  return (
    <div className={`gp-feedback${small ? ' small' : ''}`} style={style}>
      {step === STEPS.DURATION && (
        <Duration
          overtime={appointment.overtime}
          duration={appointment.duration}
          small={small}
          onSubmit={(duration) => update({ duration })}
        />
      )}
      {step === STEPS.CLASSROOM_REVIEW && (
        <Review
          person={person}
          onSubmit={(review) => submitClassroomFeedback(review)}
          onExit={next}
          type='CLASSROOM'
        />
      )}
      {step === STEPS.RATING && (
        <Rating
          person={person}
          small={small}
          onSubmit={(rating) => update({ rating })}
        />
      )}
      {step === STEPS.REVIEW && (
        <Review
          person={person}
          small={small}
          isTutor={isTutor(self.type)}
          onSubmit={(review) => update({ review })}
          onExit={exit}
          onBook={exitToSessionRequest}
          type='SESSION'
        />
      )}
      {step === STEPS.END && <End small={small} onExit={exit} />}

      {updating && <Loader icon full />}
    </div>
  )
}

export default Feedback
